import styled from 'styled-components';

const MainPaper = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 24px 20px;
`;

export default MainPaper;
